/**
 * Tutorial auto-trigger is now disabled.
 * Users can start tutorials manually from their profile.
 */
const TutorialAutoTrigger = () => {
  // Auto-prompt disabled to avoid interrupting users on login.
  // Tutorials remain available under Profile > Settings > Tutorials.
  return null;
};

export default TutorialAutoTrigger;
